import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { PoliciesListTable } from './policies-list-table';

export const PoliciesListPage = () => {
  return (
    <div className=''>
      <Link to='/dashboard' className='flex items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>All Policies</h2>
      </Link>
      <div className='mt-8 border-t'>
        <PoliciesListTable />
      </div>
    </div>
  );
};
